.container {
  padding: 1rem;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.container li {
  margin: 0;
}

.header-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 8px;
  padding: 1rem;
}

.event-summary {
  margin: 0;
}

.broader-context {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 8px;
  padding: 1rem;
}

.broader-context-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
}

.broader-context-event {
  padding: 1rem;
  border-radius: 8px;
}

.broader-context-event-text {
  border-radius: 8px;
}

.retrieval-time {
  padding: 1rem;
  margin: 0;
  font-size: 0.8rem;
  color: var(--dark-grey);
}
